import React from 'react';
import PropTypes from 'prop-types';
import { InformationFlow, ShareComment, Img, WxLaunchApp, PageBottomBrand } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';
import styles from './index.css';
import { getQueryString, getSingleNewsData, formatHotNewsData, getHotspotType } from '../../../services/api';
import { withBottomSlide } from '@ifeng-fe/container_channel/common/client/components/withBottomSlide';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import errorBoundary from '@ifeng-fe/errorBoundary';

const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
const BottomCommont = function BottomCommont({ IS_GROUP, content, wxLaunch }) {
    const eventName = getQueryString('eventName');
    const groupid = getQueryString('groupid', '');
    const docid = getQueryString('docid', '');
    const aid = getQueryString('aid', '');
    const type = getQueryString('type', '');
    const from = getQueryString('from', '');
    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

    const topicId = IS_GROUP
        ? `https://${ nineDomain }/hotSpotCrowdV2?groupid=${groupid}&aid=${aid}&type=${type}&page=1`
        : `https://${ nineDomain }/hotSpotDetailListV2?eventName=${eventName}&docid=${docid}&groupid=${groupid}&type=customPage`;

    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';

    const articleInfo = {
        isVideoShare,
        topicId,
        kind: from === 'huaweiAds' ? 'brand_hwads08' : 'share52205',
        callType: 'customPage',
        docUrl: content.chConfig.chid, // 文章单页的页面地址
        docTitle: content.chConfig.chname, // 文章的标题
        speUrl: '', // 兼容以后的专题评论
        pcUrl: content.chConfig.weburl, // 文章pc的页面地址
        cmtNumUrl: `https://${ commentDomain }/get.php`, // 获取评论内容接口
        cmtLength: 1000, // 评论内容字数长度
        cmtPostUrl: `https://${ commentDomain }/post.php`, // 提交评论内容接口
        hotLimit: 6, // 最热评论数量
        limitHeight: '', // 评论区域的高度限制
        cmtVoteUrl: `https://${ commentDomain }/vote.php`, // 推荐评论接口
        replyLimit: 3, // 显示回复的楼层
        jubUrl: `https://${ commentDomain }/report`, // 举报提交接口
        jubNum: 0, // 举报次数，便于每次回调函数名不同
        isComment: false, // 是否是评论详情页面
        allowComment: true, // 是否允许评论
        noKindFrom: from === 'huaweiAds' ? 1 : 0,
        clickCount: {
            behavior: 'action',
            type: 'comtmore',
            other: {
                ref: encodeURIComponent(topicId),
                kind: 'topic',
                url: typeof window !== 'undefined' ? encodeURIComponent(location.href) : '',
            },
        },
        downloads: isVideoShare
            ? {}
            : {
                  download:
                      from === 'huaweiAds'
                          ? 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902260146694144'
                          : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1447785374780',
                  downloadAd:
                      from === 'huaweiAds'
                          ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9115'
                          : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8778',
              },
        wxLaunchType: wxLaunch.wxLaunchType,
        wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
        weappLink: `pages/special/special.html?id=hot_in_${eventName}&from=wxh5`,
    };

    return (
        <div className={styles.comment}>
            <ShareComment articleInfo={articleInfo} />
        </div>
    );
};

BottomCommont.propTypes = {
    content: PropTypes.object.isRequired,
    IS_GROUP: PropTypes.bool,
    wxLaunch: PropTypes.object,
};

@withBottomSlide
class Layout extends React.PureComponent {
    static propTypes = {
        getFooterSlideData: PropTypes.func,
        setWechatConfig: PropTypes.func,
        content: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.state = {
            IS_GROUP: props.content.IS_GROUP,
            content: null,
        };
    }

    initData = data => {
        if (!data.data) return;
        data = data.data;

        if (data.chConfig.chname) data.chConfig.chname = data.chConfig.chname.replace(/(^#)|(#$)/g, '');

        if (data.chConfig.offline === '-1' && typeof window !== 'undefined') {
            location.href = 'https://ishare.ifeng.com/hotNewsShare404';
        }

        // data.list[0].item = formatHotNewsData(data.list[0].item, undefined);
        if (data.list[0]) data.list[0].item = formatHotNewsData(data.list[0].item, undefined);
        if (data.list[1]) data.list[1].item = formatHotNewsData(data.list[1].item, undefined);

        // console.log(data.list[1].item, '2222222')

        data.list.forEach(_data => {
            // _data.item = _data.item.filter(item => !item.vote);
            _data.item.map(item => (item.url = item?.link?.weburl || item?.link?.url || ''));
        });

        return data;
    };

    async componentDidMount() {
        const { IS_GROUP } = this.state;
        const eventName = getQueryString('eventName');
        const groupid = getQueryString('groupid');
        const docid = getQueryString('docid', '');
        const aid = getQueryString('aid', '');
        const type = getQueryString('type', '');
        const from = getQueryString('from', '');

        try {
            if (eventName) {
                const hotspotType = await getHotspotType(eventName);

                // 热点转专题逻辑
                if (hotspotType && hotspotType === 'special') {
                    location.href = `https://ishare.ifeng.com/c/s/${eventName}`;

                    return false;
                }
            }
        } catch (error) {
            console.error(error);
        }
        const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

        // try {
        let data = await getSingleNewsData({
            page: 0,
            PAGE_INFO: {
                staId: 'hot_merge',
                api: IS_GROUP ? `//${ nineDomain }/hotSpotCrowd` : `https://${ nineDomain }/hotSpotDetailList`,
                method: 'get',
                params: {
                    eventName,
                    groupid,
                    docid,
                    aid,
                    type,
                },
                noFormatData: true,
            },
        });

        data = this.initData(data);
        this.setState({ content: data });

        this.props.getFooterSlideData({
            title: data.chConfig.chname,
            id: data.chConfig.chname,
            from: 'share_relate_foot_rjdy',
            staId: data.listId,
        });

        this.props.setWechatConfig({
            title: data.shareInfo.title,
            img:
                data.shareInfo.thumbnail?.replace('.webp', '').replace('_webp/', '/') ||
                'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
        });

        if (from === 'huaweiAds') {
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'page',
                    type: 'other',
                    other: {
                        id: 'hwadsht',
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(location.href),
                    },
                },
            ]);
        } else {
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'page',
                    type: 'h5',
                    kind: 'inter_fxy05',
                    other: {
                        id: IS_GROUP ? `group_${groupid}` : `hot_in_${groupid}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(location.href),
                    },
                },
            ]);
        }
        // } catch (err) {
        //     console.error(err);
        // }
    }

    render() {
        if (!this.state || !this.state.content) return null;

        const { content, IS_GROUP } = this.state;
        const { unfoldType, isVideoShare, pageBottomPic } = this.props.content;
        const wxLaunch = (unfoldType && unfoldType.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const eventName = getQueryString('eventName');
        const groupid = getQueryString('groupid', '');
        const docid = getQueryString('docid', '');
        const aid = getQueryString('aid', '');
        const type = getQueryString('type', '');
        const from = getQueryString('from', '');
        const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

        const schemeLink =
            wxLaunchConfig.wxLaunchType === 'weapp'
                ? `pages/special/special.html?id=hot_in_${eventName}&from=wxh5`
                : getSchemeLink({
                      docType: 'customPage',
                      pid: IS_GROUP
                          ? `https://${ nineDomain }/hotSpotCrowdV2?groupid=${groupid}&aid=${aid}&type=${type}&page=1`
                          : `https://${ nineDomain }/hotSpotDetailListV2?eventName=${eventName}&docid=${docid}&groupid=${groupid}&type=customPage`,
                      kind: 'inter_fxy05',
                      noKindFrom: 1,
                  });
        const brandPic = isVideoShare ? pageBottomPic.videoBrandPic : pageBottomPic.newBrandPic;

        const callAppConfig = brandPic
            ? {
                  docType: 'custom',
                  kind: from === 'huaweiAds' ? 'brand_hwads08' : 'share52202',
                  pid:
                      (pageBottomPic.schemeUrl && `${pageBottomPic.schemeUrl}&timeStamp=${new Date().getTime()}`) || '',
                  download:
                      from === 'huaweiAds'
                          ? 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902260146694144'
                          : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1475599819841',
                  downloadAd:
                      from === 'huaweiAds'
                          ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9115'
                          : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8826',
                  noKindFrom: from === 'huaweiAds' ? 1 : 0,
              }
            : {
                  docType: 'customPage',
                  kind: from === 'huaweiAds' ? 'brand_hwads08' : 'share52202',
                  pid: IS_GROUP
                      ? `https://${ nineDomain }/hotSpotCrowdV2?groupid=${groupid}&aid=${aid}&type=${type}&page=1`
                      : `https://${ nineDomain }/hotSpotDetailListV2?eventName=${eventName}&docid=${docid}&groupid=${groupid}&type=customPage`,
                  download:
                      from === 'huaweiAds'
                          ? 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902260146694144'
                          : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                  downloadAd:
                      from === 'huaweiAds'
                          ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9115'
                          : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                  noKindFrom: from === 'huaweiAds' ? 1 : 0,
              };
        const actionConfig = brandPic
            ? [
                  {
                      behavior: 'action',
                      type: 'openapp_phtv',
                      other: {
                          ref: encodeURIComponent(location.href),
                          kind: 'hotRank',
                      },
                  },
              ]
            : [
                  {
                      behavior: 'action',
                      type: 'downopen',
                      other: {
                          ref: encodeURIComponent(location.href),
                          kind: 'hotRank',
                      },
                  },
              ];

        return (
            <div className={styles.container}>
                <div className={`${styles.header} ${IS_GROUP ? styles.headerNoMask : ''}`}>
                    <div className={`${styles.banner} ${IS_GROUP ? styles.bannerNoFilter : null}`}>
                        <Img
                            src={
                                content.chConfig.backgroundImg
                                    ? content.chConfig.backgroundImg.replace('.webp', '').replace('_webp/', '/')
                                    : require('../assets/back.png')
                            }
                        />
                    </div>
                    <div className={styles.title}>
                        <div>{content.chConfig.chname}</div>
                        <div>{content.chConfig.pv ? <span>{content.chConfig.pv}关注</span> : null}</div>
                    </div>
                    <div
                        className={styles.watch}
                        onClick={() => {
                            const eventName = getQueryString('eventName');
                            const groupid = getQueryString('groupid', '');
                            const docid = getQueryString('docid', '');
                            const aid = getQueryString('aid', '');
                            const type = getQueryString('type', '');
                            const from = getQueryString('from', '');
                            const client = isVideoShare ? 'videoApp' : 'newsApp';
                            const downloadVal = isVideoShare
                                ? {}
                                : {
                                      download:
                                          'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1447785374780',
                                      downloadAd:
                                          'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8778',
                                  };

                            h5PageCount([
                                {
                                    behavior: 'action',
                                    type: 'hot_more',
                                    other: {
                                        ref: 'hot_merge',
                                    },
                                },
                            ]);
                            const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

                            callApp({
                                client,
                                docType: 'customPage',
                                pid: IS_GROUP
                                    ? `https://${ nineDomain }/hotSpotCrowdV2?groupid=${groupid}&aid=${aid}&type=${type}&page=1`
                                    : `https://${ nineDomain }/hotSpotDetailListV2?eventName=${eventName}&docid=${docid}&groupid=${groupid}&type=customPage`,
                                kind: from === 'huaweiAds' ? 'brand_hwads08' : 'inter_fxy05',
                                noKindFrom: 1,
                                download:
                                    from === 'huaweiAds'
                                        ? 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902260146694144'
                                        : downloadVal.download,
                                downloadAd:
                                    from === 'huaweiAds'
                                        ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9115'
                                        : downloadVal.downloadAd,
                            });
                        }}>
                        <img src={require('../assets/focuse_icon.png')} alt="" />
                        {!isVideoShare &&
                            wxLaunchConfig.wxLaunchSwitch && (
                                <WxLaunchApp
                                    launchType={wxLaunchConfig.wxLaunchType}
                                    launchAppClick={() => {
                                        h5PageCount([
                                            {
                                                behavior: 'action',
                                                type: 'carefor',
                                                other: {
                                                    ref: `ucms_${content.base62Id}`,
                                                    kind: content.type || 'article',
                                                },
                                            },
                                        ]);
                                    }}
                                    schemeLink={schemeLink}
                                    launchAppFail={() => {
                                        const eventName = getQueryString('eventName');
                                        const groupid = getQueryString('groupid', '');
                                        const docid = getQueryString('docid', '');
                                        const aid = getQueryString('aid', '');
                                        const type = getQueryString('type', '');
                                        const client = isVideoShare ? 'videoApp' : 'newsApp';
                                        const downloadVal = isVideoShare
                                            ? {}
                                            : {
                                                  download:
                                                      'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1447785374780',
                                                  downloadAd:
                                                      'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8778',
                                              };

                                        h5PageCount([
                                            {
                                                behavior: 'action',
                                                type: 'hot_more',
                                                other: {
                                                    ref: 'hot_merge',
                                                    tag: 't9',
                                                },
                                            },
                                        ]);
                                        const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

                                        callApp({
                                            client,
                                            docType: IS_GROUP ? 'hotspotlist' : 'customPage',
                                            pid: IS_GROUP
                                                ? `https://${ nineDomain }/hotSpotCrowd?groupid=${groupid}&aid=${aid}&type=${type}&page=1`
                                                : `https://${ nineDomain }/hotSpotDetailListV2?eventName=${eventName}&docid=${docid}&groupid=${groupid}&type=customPage`,
                                            kind: 'inter_fxy05',
                                            noKindFrom: 1,
                                            download: downloadVal.download,
                                            downloadAd: downloadVal.downloadAd,
                                            isCopySchemeUrl: true,
                                        });
                                    }}
                                />
                            )}
                    </div>
                </div>
                <div className={styles.news}>
                    {content.chConfig.intro ? (
                        <div className={styles.desc}>
                            <span>{content.chConfig.intro}</span>
                        </div>
                    ) : null}
                    {/* <div className={styles.news_title}>
                        <img src={require('../assets/title_icon.png')} alt="" />
                        <div>{IS_GROUP ? '精选内容' : '精选热点'}</div>
                    </div> */}
                    {IS_GROUP ? null : (
                        <div className={styles.news_title}>
                            <img src={require('../assets/title_icon.png')} alt="" />
                            <div>精选热点</div>
                        </div>
                    )}
                    <InformationFlow
                        isFormatTime={true}
                        isNewsTime={true}
                        content={content.list[0].item}
                        isDisplayLoadingMore={false}
                    />
                    {content.list[1] ? (
                        <div>
                            <div className={styles.news_title}>
                                <div />
                                <div>相关推荐</div>
                            </div>
                            <InformationFlow content={content.list[1].item} isDisplayLoadingMore={false} />
                        </div>
                    ) : null}
                </div>
                <div className={styles.bottom}>
                    <BottomCommont IS_GROUP={IS_GROUP} content={content} wxLaunch={wxLaunchConfig} />
                </div>
                <PageBottomBrand
                    brandPic={brandPic}
                    isVideoShare={isVideoShare}
                    callAppConfig={callAppConfig}
                    actionConfig={actionConfig}
                    wxLaunchConfig={wxLaunchConfig}
                />
            </div>
        );
    }
}

export default errorBoundary(Layout);
